import { PartnerFormData } from 'forms/PartnerForm';
import ClowncarAppConstants from 'constants/ClowncarAppConstants';
import protos from 'utils/protos';

const { Partner } = protos;

export function insert(request: PartnerFormData): ApiAction {
  return {
    TockApi: {
      postProto: `/partner/internal?adminEmail=${request.adminEmail}`,
      type: ClowncarAppConstants.PARTNER_INSERT,
      request: Partner.fromObject(request),
      toast: 'Partner added to Tock',
    },
  };
}

export function fetchAll(): ApiAction {
  return {
    TockApi: {
      getListProto: '/partner/internal/all',
      type: ClowncarAppConstants.PARTNER_FETCH_ALL,
    },
  };
}
